import {useEffect, useState} from "react";
import bin_logo from "../assets/bin.png";
import resurrect_logo from "../assets/ressurect.png";
import people_api from "../api/admin/admin_people";
import orgadmin_people_api from "../api/orgadmin/orgadmin_people";
import team_api from "../api/admin/admin_teams";
import orgadmin_team_api from "../api/orgadmin/orgadmin_teams";
import orgadmin_user_status_api from "../api/orgadmin/orgadmin_user";
import OrganisationAddMembers from "./OrganisationAddMembers";
import RequestAdminPopup from "./RequestAdminPopup";
import roles from "../models/Roles";
import teams from "../models/Teams";
import org_admin_api from "../api/orgadmin/orgadmin_orgs";
import admin_orgs from "../api/admin/admin_orgs";
import OrganisationAddNotificationMembers from "./OrganisationAddNotificationMember";

const OrganisationPeople = (props) => {
    const profile = props.profile;
    const organisation = props.organisation;
    const [admins, setAdmins] = useState();
    const [notificationList, setNotificationList] = useState();
    const [people, setPeople] = useState();
    const [teamName, setTeamName] = useState();
    const [showGrids, setShowGrids] = useState(true);
    const [showAddMembers, setShowAddMembers] = useState(false);
    const [showRequestPopup, setShowRequestPopup] = useState(false);
    const [showAddNotificationMember, setShowAddNotificationMember] = useState(false)
    const [role, setRole] = useState()
    const [team, setTeam] = useState()

    const getPeople = () => {
        if (!profile) return
        let response = null

        if (profile.role_id === roles.ROLE_ADMIN) {
            response = people_api.getPeople(organisation.id)
        }
        if (profile.role_id === roles.ROLE_ORGANISATION_ADMIN) {
            response = orgadmin_people_api.getPeople()
        }
        if (!response) return

        response.then(res => {
            const teams = res.data?.people?.teams
            if (Array.isArray(teams) && teams.length > 0) {
                setAdmins(teams[0])
                const rest = teams.slice(1)
                setPeople(rest)
            } else {
                setAdmins(null)
                setPeople([])
            }
        }).catch(err => {
            console.error("Failed to fetch people:", err)
            setAdmins(null)
            setPeople([])
        })
    }


    const hideAddMember = () => {
        getPeople()
        setShowAddMembers(false)
        setShowGrids(true)
    }

    const getNotificationList = () => {
        if (!profile) return
        let response = null
        if (profile.role_id === roles.ROLE_ADMIN) {
            response = admin_orgs.getOrgNotificationList(organisation.id)
        }
        if (profile.role_id === roles.ROLE_ORGANISATION_ADMIN) {
            response = org_admin_api.getOrgNotificationList()
        }
        response.then(response => {
            setNotificationList(response.data.list)
        }).catch((err) => {
            console.log(err)
        })
    }

    const hideAddNotificationMember = () => {
        getNotificationList()
        setShowAddNotificationMember(false)
        setShowGrids(true)
    }

    const handleRemoveUser = (ev) => {
        if (!ev) return
        const body = {
            "user_email": ev.target.id,
            "status": 2
        }
        let response = orgadmin_user_status_api.updateUserStatus(body)
        response.then(
            response => {
                getPeople()
            }
        )
    }

    const handleRemoveNotificationMember = (ev) => {
        if (!ev) return
        if (!profile) return
        let response = null
        const body = {
            "id": ev.target.id
        }
        if (profile.role_id === roles.ROLE_ADMIN) {
            response = admin_orgs.putOrgNotificationList(organisation.id, body)
        }
        if (profile.role_id === roles.ROLE_ORGANISATION_ADMIN) {
            response = org_admin_api.putOrgNotificationList(body)
        }
        response.then(
            response => {
                getNotificationList()
            }
        )
    }

    const handleResurrectUser = (ev) => {
        if (!ev) return
        const body = {
            "user_email": ev.target.id,
            "status": 1
        }
        let response = orgadmin_user_status_api.updateUserStatus(body)
        response.then(
            response => {
                getPeople()
            }
        )
    }

    const handleAddUserClick = (ev) => {
        if (!ev) return
        if (!people) return
        setTeam(ev.target.id)
        setRole(roles.ROLE_USER)
        setShowGrids(false)
        setShowAddMembers(true)
    }
    const handleAddAdminClick = (ev) => {
        if (!ev) return
        if (!admins) return
        setTeam(admins.id);
        setRole(roles.ROLE_ORGANISATION_ADMIN);
        setShowGrids(false);
        setShowAddMembers(true);
    }

    const handleAddNotificationMember = () => {
        setShowGrids(false);
        setShowAddNotificationMember(true)
    }

    const handleRequestAdminClick = () => {
        setShowRequestPopup(true);
    }

    const updateShowPopup = (show) => {
        setShowRequestPopup(show);
    }

    const handleNewTeamClick = () => {
        if (!teamName) return;
        if (!profile) return;

        const body = {
            "name": teamName
        }
        let response = null;
        if (profile.role_id === roles.ROLE_ADMIN) {
            response = team_api.createTeam(organisation.id, body);
        }
        if (profile.role_id === roles.ROLE_ORGANISATION_ADMIN) {
            response = orgadmin_team_api.createTeam(body);
        }

        response.then(
            response => {
                setTeamName(undefined);
                getPeople();
            }
        )
    }

    useEffect(() => {
        getPeople()
        getNotificationList()
    }, [])

    return (
        <>
            <div className="people-container">
                {showGrids ?
                    <>
                        <div className="people-title">
                            {organisation && organisation.name} People
                        </div>
                        <div className="people-admins-grid">
                            <div className="people-admins-grid-title-container">
                                <div className="people-admins-grid-title">Organisation Admins</div>
                                {profile && profile.role_id === roles.ROLE_ADMIN ?
                                    <>
                                        <div className="people-admins-grid-add-button link"
                                             onClick={handleAddAdminClick}>
                                            Add new admin
                                        </div>
                                    </>
                                    : null}
                                {profile && profile.role_id === roles.ROLE_ORGANISATION_ADMIN ?
                                    <>
                                        <div className="people-admins-grid-add-button link"
                                             onClick={handleRequestAdminClick}>
                                            Request new admin
                                        </div>
                                    </>
                                    : null}
                                {showRequestPopup ? <RequestAdminPopup update={updateShowPopup.bind(this)}/>
                                    : null}

                            </div>
                            <div className="people-admins-grid-col-headers">
                                <div className="name col">Name</div>
                                <div className="email col">Email</div>
                                <div className="status col">Status</div>
                                <div className="valuations col">Valuations this month</div>
                                <div className="action col"></div>
                            </div>
                            <div className="people-admins-grid-rows">
                                {admins && admins.team_members && admins.team_members.map((person, idx) => {
                                    return (
                                        <>
                                            <div className="people-admins-grid-row">
                                                <div className="name col">
                                                    {!person.firstname ? "{pending}" : person.firstname + " " + person.lastname}
                                                </div>
                                                <div className="email col">{person.email}</div>
                                                <div
                                                    className="status col">{person.status === 1 ? "Active" : "Inactive"}</div>
                                                <div className="valuations col">{person.valuations_this_month}</div>
                                                <div className="action col">
                                                    {person.status === 1 ?
                                                        <img src={bin_logo} alt="Bin icon" className="link"
                                                             onClick={handleRemoveUser} id={person.email}/>
                                                        :
                                                        <img src={resurrect_logo} alt="Resurrect icon" className="link"
                                                             onClick={handleResurrectUser} id={person.email}/>
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    )
                                })}
                            </div>
                        </div>
                        {profile && (profile.role_id === roles.ROLE_ADMIN) ?
                            <div className="people-admins-grid">
                                <div className="people-admins-grid-title-container">
                                    <div className="people-admins-grid-title">Notification List</div>
                                    <div className="people-admins-grid-add-button link"
                                         onClick={handleAddNotificationMember}>
                                        Add team member
                                    </div>
                                </div>
                                <div className="people-admins-grid-col-headers">
                                    <div className="name col">Name</div>
                                    <div className="email col">Email</div>
                                    <div className="action col"></div>
                                </div>
                                <div className="people-admins-grid-rows">
                                    {notificationList && notificationList.map((person, idx) => {
                                        return (
                                            <>
                                                <div className="people-admins-grid-row">
                                                    <div className="name col">
                                                        {person.name}
                                                    </div>
                                                    <div className="email col">{person.email}</div>
                                                    <div className="notifications-action col">
                                                        <img src={bin_logo} alt="Bin icon" className="link"
                                                             onClick={handleRemoveNotificationMember} id={person.id}/>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                            </div>
                            : null}
                        <div className="people-teams-grid-container">
                            <div className="people-teams-grid-title">Organisation Teams</div>
                            {people && people.map((team, idx) => {
                                return (
                                    <>
                                        <div className="people-team-grid">
                                            <div className="people-team-grid-title-container">
                                                <div className="people-team-grid-title">{team.name}</div>
                                                {team.id !== teams.TEAM_RETAIL ?
                                                    <div className="people-team-grid-add-button link"
                                                         onClick={handleAddUserClick}
                                                         id={team.id}>
                                                        Add team member
                                                    </div> : null}
                                            </div>
                                            <div className="people-team-grid-col-headers">
                                                <div className="name col">Name</div>
                                                <div className="email col">Email</div>
                                                <div className="status col">Status</div>
                                                <div className="valuations col">Valuations this month</div>
                                                <div className="action col"></div>
                                            </div>
                                            <div className="people-team-grid-rows">
                                                {team.team_members && team.team_members.map((person, idx) => {
                                                    return (
                                                        <>
                                                            <div className="people-admins-grid-row">
                                                                <div className="name col">
                                                                    {!person.firstname ? "{pending}" : person.firstname + " " + person.lastname}
                                                                </div>
                                                                <div className="email col">{person.email}</div>
                                                                <div
                                                                    className="status col">{person.status === 1 ? "Active" : "Inactive"}</div>
                                                                <div
                                                                    className="valuations col">{person.valuations_this_month}</div>
                                                                <div className="action col">
                                                                    {person.status === 1 ?
                                                                        <img src={bin_logo} alt="Bin icon"
                                                                             className="link"
                                                                             onClick={handleRemoveUser}
                                                                             id={person.email}/>
                                                                        :
                                                                        <img src={resurrect_logo} alt="Resurrect icon"
                                                                             className="link"
                                                                             onClick={handleResurrectUser}
                                                                             id={person.email}/>
                                                                    }                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                            <div className="people-teams-new-container">
                                <div className="people-teams-new-label">Create new team</div>
                                <div className="people-teams-new-fields">
                                    <div className="name">
                                        <input type="text" value={teamName}
                                               onChange={(ev) => setTeamName(ev.target.value)}
                                               placeholder="Type new team name"/>
                                    </div>
                                    <div className="button link" onClick={handleNewTeamClick}>Save</div>
                                </div>
                            </div>
                        </div>
                    </>
                    : null}
                {showAddMembers ?
                    <>
                        <OrganisationAddMembers role={role} team={team} hide={hideAddMember.bind(this)}
                                                profile={profile}/>
                    </>
                    : null}
                {showAddNotificationMember ?
                    <>
                        <OrganisationAddNotificationMembers role={role}
                                                            hide={hideAddNotificationMember.bind(this)}
                                                            profile={profile}
                                                            org_id={organisation.id}/>
                    </>
                    : null}

            </div>
        </>
    )
}

export default OrganisationPeople